import { readBetGameSettingList } from '@/api/bet/read';
import Header from '@/component/Header';
import { betGameSettingListColumns } from '@/component/bet/table/BetColumnData';
import { Tables } from '@/component/pools/table/Tables';
import { packBigNumbers } from '@/lib/BigNumbers';
import { SUCCESS } from '@/lib/common/name-space';
import { AddIndexResReadBetGameSettingListType, ResReadBetGameSettingListType } from '@/types';
import { Box, Button, Card, CardContent, Divider } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BetGameSettingList() {
  const [list, setList] = useState<AddIndexResReadBetGameSettingListType[]>([]);

  const navigate = useNavigate();

  const addBetGameSettingListColumns: GridColDef[] = [
    ...betGameSettingListColumns,
    {
      flex: 1,
      minWidth: 100,
      field: 'shortTxHash',
      headerName: '버튼',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <>
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                navigate('/bet-game-setting-detail', {
                  state: {
                    gameSettingId: params.row.gameSettingId,
                  },
                })
              }
            >
              상세
            </Button>
          </Box>
        </>
      ),
    },
  ];

  useEffect(() => {
    (async () => {
      const re = await readBetGameSettingList();
      if (re.status !== SUCCESS) {
        return;
      }
      const data = re.data.map((item: ResReadBetGameSettingListType, index: number) => ({
        ...item,
        index: index + 1,
        totAmountName: packBigNumbers(item.totAmount),
        jackpotAmountName: packBigNumbers(item.jackpotAmount),
        jackpotReadyName: packBigNumbers(item.jackpotReady),
      }));
      setList(data);
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <Card>
          <Header title="게임 리스트" />
          <Divider />
          <Box mb={2} />
          <Box display="flex" gap={2} mb={2}>
            <Button
              variant="contained"
              onClick={() => {
                navigate('/bet-game-setting');
              }}
            >
              신규 생성
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                navigate('/bet-common-setting');
              }}
            >
              공통 세팅
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                navigate('/bet-jackpot-setting');
              }}
            >
              잭팟 세팅
            </Button>
          </Box>
          <CardContent>{list && <Tables list={list} columns={addBetGameSettingListColumns} />}</CardContent>
        </Card>
      </Box>
    </>
  );
}
